import { Navigate } from "react-router-dom";
import { useUser } from "contexts/UserContext";
import LoadingBanner from "./LoadingBanner";

/**
 * Wrap routes to check for token validity.
 * @param {Object} props
 * @param {JSX.Element} props.children The children components for the route.
 * @returns {JSX.Element}
 */
function PrivateRoute({ children }) {
  const { isLoggedIn, loading } = useUser();

  if (loading) {
    return <LoadingBanner />;
  }

  return isLoggedIn ? children : <Navigate to="/sign-in" />;
}

export default PrivateRoute;
